var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.034 9.84939L37.7667 31.2874C38.804 33.4241 37.2516 35.9501 34.8484 35.9501H13.4382C11.035 35.9501 9.48266 33.4242 10.52 31.2874L10.5237 31.2797L21.2527 9.84939C22.4247 7.45027 25.862 7.45027 27.034 9.84939ZM25.7771 10.466C25.1172 9.11139 23.1694 9.11139 22.5095 10.466L22.5062 10.4729L11.7777 31.9024C11.1911 33.1171 12.0794 34.5501 13.4382 34.5501H34.8484C36.2073 34.5501 37.0956 33.117 36.5089 31.9023L25.7771 10.466Z",
    fill: "#FFA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2756 29.9436C23.2756 30.4269 23.6674 30.8186 24.1506 30.8186C24.6339 30.8186 25.0256 30.4269 25.0256 29.9436C25.0256 29.4604 24.6339 29.0686 24.1506 29.0686C23.6674 29.0686 23.2756 29.4604 23.2756 29.9436Z",
    fill: "#FFA6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1507 16.4182C24.5373 16.4182 24.8507 16.7316 24.8507 17.1182V26.1182C24.8507 26.5048 24.5373 26.8182 24.1507 26.8182C23.7641 26.8182 23.4507 26.5048 23.4507 26.1182V17.1182C23.4507 16.7316 23.7641 16.4182 24.1507 16.4182Z",
    fill: "#FFA6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3ac5f42b1e26ecfb068cc9626aba3a80.svg";
export { ForwardRef as ReactComponent };